import React from 'react'
import LetterBoxContainer from '../../../Components/Applications/LetterBox'
import { LetterBoxFilterProvider } from "../../../Features/letterBox/context/FilterContext";


export default function LetterBox() {
    return (
        <div className='page-body'>
            <LetterBoxFilterProvider>
                <LetterBoxContainer />
            </LetterBoxFilterProvider>
        </div>
    )
}